// apiConfig.js
// const apiBaseUrl = 'http://localhost:5000';


const apiBaseUrl = 'https://backend.paratiritirio-edsna.gr:5000';

export default apiBaseUrl;